module.exports = __webpack_public_path__ + "assets/img/payBg.39347735.png";